import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCatalogsComponent } from './components/list-catalogs/list-catalogs.component';
import { AddCatalogsComponent } from './components/add-catalogs/add-catalogs.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InsertingProductsComponent } from './components/inserting-products/inserting-products.component';
import { CustomCatalogProductsComponent } from './components/custom-catalog-products/custom-catalog-products.component';
import { InsertingLocationsComponent } from './components/inserting-locations/inserting-locations.component';
import { CustomeOverrideComponent } from './components/custome-override/custome-override.component';
import { EditBasicCatalogsInfosComponent } from './components/edit-basic-catalogs-infos/edit-basic-catalogs-infos.component';
import { EditGeneralRulesComponent } from './components/edit-general-rules/edit-general-rules.component';
import { DetailsCatalogComponent } from './components/details-catalog/details-catalog.component';
import { CatalogsFilterComponent } from './components/catalogs-filter/catalogs-filter.component';
import { ConfirmNotificationComponent } from './components/confirm-notification/confirm-notification.component';
import { ShareCatalogComponent } from './components/share-catalog/share-catalog.component';
import { NewCatalogComponent } from './components/new-catalog/new-catalog.component';
import { NewCatalogSettingsComponent } from './components/new-catalog/new-catalog-settings/new-catalog-settings.component';
import { NewCatalogProductsComponent } from './components/new-catalog/new-catalog-products/new-catalog-products.component';
import { NewCatalogAddProductsComponent } from './components/new-catalog/new-catalog-add-products/new-catalog-add-products.component';
import { SelecteableProductsListComponent } from './components/new-catalog/new-catalog-add-products/selecteable-products-list/selecteable-products-list.component';
import { NewCatalogAgentsComponent } from './components/new-catalog/new-catalog-agents/new-catalog-agents.component';
import { NewCatalogConfirmationDialogComponent } from './components/new-catalog/new-catalog-confirmation-dialog/new-catalog-confirmation-dialog.component';
import { UiModule } from "../../ui/ui.module";
import { ProductDetailsDialogComponent } from './components/new-catalog/new-catalog-add-products/selecteable-products-list/product-details-dialog/product-details-dialog.component';
import { NewCatalogAudienceListComponent } from './components/new-catalog/new-catalog-audience-list/new-catalog-audience-list.component';
import { CatalogPriceRulesComponent } from './components/new-catalog/catalog-price-rules/catalog-price-rules.component';
import { ObjectCustomFieldsViewComponent } from 'src/app/shared/components/object-custom-fields-view/object-custom-fields-view.component';
import { CatalogCustomFieldsComponent } from './components/catalog-custom-fields/catalog-custom-fields.component';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';
@NgModule({
  declarations: [
    ListCatalogsComponent,
    AddCatalogsComponent,
    InsertingProductsComponent,
    CustomCatalogProductsComponent,
    InsertingLocationsComponent,
    CustomeOverrideComponent,
    EditBasicCatalogsInfosComponent,
    EditGeneralRulesComponent,
    DetailsCatalogComponent,
    CatalogsFilterComponent,
    ConfirmNotificationComponent,
    ShareCatalogComponent,
    NewCatalogComponent,
    NewCatalogSettingsComponent,
    NewCatalogProductsComponent,
    NewCatalogAddProductsComponent,
    SelecteableProductsListComponent,
    NewCatalogAgentsComponent,
    NewCatalogConfirmationDialogComponent,
    ProductDetailsDialogComponent,
    NewCatalogAudienceListComponent,
    CatalogCustomFieldsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    CatalogPriceRulesComponent,
    ObjectCustomFieldsViewComponent,
    ObjectCustomFieldsFormComponent,
]
})
export class CatalogsModule { }
